import { Component, OnInit } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../../admin.service';
import { HyperlinkService } from '@shared/services/hyperlink.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SnackService } from '@shared/services/snack.service';
import { IHyperlink } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-hyperlink-edit',
    templateUrl: './admin-hyperlink-edit.component.html',
    styleUrls: ['./admin-hyperlink-edit.component.scss'],
    standalone: false
})
export class AdminHyperlinkEditComponent extends AdminActionsDirective implements OnInit {
    formGroup: UntypedFormGroup;

    constructor(
        private hyperlinkService: HyperlinkService,
        private fb: UntypedFormBuilder,
        private snack: SnackService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    ngOnInit(): void {
        this.buildForm();
    }

    private buildForm() {
        this.formGroup = this.fb.group({
            id: this.item.id,
            title: [this.item.title, Validators.required],
            titleDe: this.item.titleDe,
            urlLink: [this.item.urlLink, Validators.required],
            urlLinkDe: this.item.urlLinkDe,
            description: this.item.description,
            descriptionDe: this.item.descriptionDe
        });
    }

    async updateItem(event: any): Promise<void> {
        this.disableSubmitter(event);

        if (this.formGroup.valid) {
            try {
                const result = await this.hyperlinkService.updateItem(this.formGroup.value);
                this.snack.openSnackBarSuccess(`Hyperlink item ${result.title} updated successfully.`);
                this.goToHyperlink(result);
            } catch (e) {
                this.snack.openSnackBarError(e.error.message);
            }
        } else {
            this.snack.openSnackBarError('Please check your input.');
        }

        this.enableSubmitter(event);
    }

    get item(): IHyperlink {
        return this.selectedItem;
    }
}
